import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { UserDataService } from '../../../shared/services/auth/userData.service';
import { IReview } from '../../../shared/models/review';
import { ReviewService } from '../../../shared/services/review.service';

@Component({
  selector: 'review-cancel',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-cancel.component.html',
  styleUrl: './review-cancel.component.css'
})
export class ReviewCancelComponent {

  @Input() caseId: string | null = null;
  @Input() stage: number | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSend = new EventEmitter<any>();

  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private reviewService: ReviewService
  ) {}

  handleSendRequest(): void {
    if (this.caseId && this.stage) {
      this.loading = true;
      const data: IReview = {
        case_id: this.caseId,
        building_id: Number(this.userDataService.getBuildingId()),
        section_review_type: this.stage
      }
      this.reviewService.cancelReviewRequest(data).subscribe({
        next: (response) => {
          this.loading = false;
          this.onSend.emit({'type': 'success', 'message': 'This occurred after cancelling a review.'});
        },
        error: (error) => {
          this.loading = false;
          this.onSend.emit({'type': 'failed', 'message': error.message});
        }
      });
    }
  }
  
  handleCloseTeam(): void {
    this.onClose.emit();
  }
}
